import moment from 'moment';

// Field Bonus (51800) was dropped from ETC forecasting starting with the
// June 18, 2026 version. Versions before the cutoff keep the section so
// history still reads exactly as it was forecast.
export const FIELD_BONUS_CUTOFF = '2026-06-18';

// True when Field Bonus should be hidden and excluded from totals for a
// version. An unknown date (live/WIP version, or the versions list still
// loading) counts as removed — every version created going forward is past
// the cutoff.
export const fieldBonusRemoved = (versionStartDateTime) =>
    !versionStartDateTime || moment(versionStartDateTime).isSameOrAfter(FIELD_BONUS_CUTOFF, 'day');

// Resolve a version GUID to its start date via the versions list, falling
// back to the WIP snapshot (which lives outside the list).
export const versionStartFor = (versions, guid, selectedWIP = null) => {
    if (selectedWIP && guid === selectedWIP.Version_GUID) return selectedWIP.Version_Start_DateTime;
    // dataSourceVersionAtom defaults to '' before the versions list loads
    if (!Array.isArray(versions)) return undefined;
    return versions.find(v => v.Version_GUID === guid)?.Version_Start_DateTime;
};
